import React from "react";
import DashboardLayout from "../components/DashboardLayout";
import AdminDashboardLayout from "../components/AdminDashboardLayout";
import AccountPage from "./AccountPage";
import { useAuth } from "../contexts/AuthContext";
import { isPrivileged } from "../utils/roles";
import { useI18n } from "../providers/I18nProvider";

const DashboardHome = () => {
  const { user, loading } = useAuth();
  const { t } = useI18n();

  if (loading) return <div style={{ padding: 16 }}>{t("common.loading")}</div>;

  const Layout = isPrivileged(user) ? AdminDashboardLayout : DashboardLayout;

  return (
    <Layout>
      <AccountPage />
    </Layout>
  );
};

export default DashboardHome;
